<template>
  <section class="auth--background">
    <div class="auth--inner">
      <h3>Logging you in to Worklogs</h3>
      <div class="slack-loader"></div>
    </div>
  </section>
</template>

<script>
  import axios from 'axios'
  import { store } from '../store/store';
  import router from 'vue-router'

  axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.slacktoken;

  export default {
    name: 'SlackAuth',
    data () {
      return {
        username: '',
        useremail: '',
        team: ''
      }
    },
    notifications: {
      showLoginError: {
        title: 'Login Failed',
        message: 'We couldn\'t sign you in.',
        type: 'error' //Default: 'info', also you can use VueNotifications.type.error instead of 'error'
      }
    },
    created () {
      var self = this;
      var getQueryString = function ( field, url ) {
        var href = url ? url : window.location.href;
        var reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
        var string = reg.exec(href);
        return string ? string[1] : null;
      }

      var _code = getQueryString('code')
      var _state = getQueryString('state')

      axios.get('https://api.kuzcoapp.com/slack/redirect?code=' + _code + '&state=' + _state)
        .then(function (response) {
          localStorage.globalsignin = true;
          localStorage.slacktoken = response.data.data.token;
          localStorage.firstload = true;

          let _username = response.data.data.user.name;
          let _email = response.data.data.user.email;
          store.commit ('_username', _username)
          store.commit ('_useremail', _email)
          self.$router.replace('/')
        })
        .catch(function (error) {
          self.showLoginError()
          self.$router.push('/')
        });
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  .auth--background{
    .slack-loader {
      margin: 0 auto;
      display: flex;
      /*display: inline-block;*/
      /*margin: 0 15px;*/
      font-size: 6px;
      text-indent: -9999em;
      width: 4em;
      height: 4em;
      border-radius: 50%;
      background: #ffffff;
      background: -moz-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
      background: -webkit-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
      background: -o-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
      background: -ms-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
      background: linear-gradient(to right, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
      position: relative;
      -webkit-animation: load3 1.4s infinite linear;
      animation: load3 1.4s infinite linear;
      -webkit-transform: translateZ(0);
      -ms-transform: translateZ(0);
      transform: translateZ(0);
    }
    .slack-loader:before {
      width: 50%;
      height: 50%;
      background: #32CD64;
      border-radius: 100% 0 0 0;
      position: absolute;
      top: 0;
      left: 0;
      content: '';
    }
    .slack-loader:after {
      background: #ffffff;
      width: 75%;
      height: 75%;
      border-radius: 50%;
      content: '';
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
    @-webkit-keyframes load3 {
      0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
    @keyframes load3 {
      0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }
  .auth--inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    h3 {
      font-size: 25px;
      margin-bottom: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// SlackAuth.vue?20a7e0a0